<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      id="result-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >
      <div slot="beforeTable" class="pt-3">
        <b-row>
          <b-col class="pr-0">
            <select-filter
              variant="info"
              placeholder="All Types"
              :collection="type_filters"
              value-key="id"
              text-key="name"
              filter-field="sample_type_id"
              filter-operator="eq"
              @onSelect="setCustomFilter('sample_type', $event)"
            />
          </b-col>
          <b-col>
            <select-filter
              variant="info"
              icon="fa-hand-holding-seedling"
              placeholder="All Growers"
              :directory="grower_filters"
              filter-field="grower"
              filter-operator="eq"
              @onSelect="setCustomFilter('filter__grower', $event)"
            />
          </b-col>
        </b-row>
      </div>

      <span slot="released_at" slot-scope="{ row }">
        <router-link :to="`/results/${row.id}`" class="btn-link">
          {{ row.released_at | moment("L") }}
        </router-link>
      </span>

      <span slot="customer" slot-scope="{ row }">
        <existence-gate
          :entity="row"
          :levels="['project', 'customer']"
          :field="'full_name'"
        >
          <template #existing-content>
            <router-link
              :to="`/customer/${getData(row, {
                levels: ['project', 'customer'],
                field: 'id',
              })}`"
            >
              {{ getData(row, { levels: ['project', 'customer'], field: "full_name" }) }}
            </router-link>
          </template>
        </existence-gate>
      </span>

      <span slot="sample_count" slot-scope="{ row }">
        {{ row.getSamples().models.length }}
      </span>

      <span slot="test_packages" slot-scope="{ row }">
        {{ getData(row, { levels: ['test_package'], field: "name" }) }}
      </span>

      <span slot="grower" slot-scope="{ row }">
        {{ getGrower(row) }}
      </span>

      <span slot="type" slot-scope="{ row }">
        {{ getData(row, { levels: ['sample_type'], field: "name" }) }}
      </span>

      <span slot="field" slot-scope="{ row }">
        {{ row.identifier }}
      </span>

      <span slot="delivered">
        <i class="fal fa-check" />
      </span>

      <span slot="viewed">
        <i class="fal fa-check" />
      </span>

      <span slot="actions" slot-scope="{ row }" class="clearfix">
        <!-- <router-link
          v-for="(document, index) in row.getResultDocuments().sortBy('type')"
          :key="index"
          :to="`/results/${row.id}/documents/${document.id}`"
          class="btn btn-sm btn-primary text-white mr-1"
        >
          <i :class="`fa fa-${document.icon()}`" />
        </router-link> -->
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ExistenceGate from "@/components/shared/ExistenceGate";
import SelectFilter from "@/components/shared/SelectFilter";
import { ServerTable } from "vue-tables-2";
import { getEntityData } from "@/shared/utils";
import SubmissionCollection from '@/collections/lab/SubmissionCollection';
import SubmissionExtensionTableDTO from "@/DTO/ExtensionTables/SubmissionExtensionTableDTO";
import { getCollection } from '@/shared/fetch-utils';

Vue.use(ServerTable);

export default {
  name: "ResultServerTable",
  extends: BaseServerTable,
  components: {
    ExistenceGate,
    ServerTable,
    SelectFilter,
  },
  props: {
    collection: {
      type: Object,
      default: () => new SubmissionCollection(),
    },
    types: {
      type: Object,
      default: () => null,
    },
    growers: {
      type: Object,
      default: () => null,
    },
    show_columns: {
      type: Array,
      default: () => [
        "released_at",
        "customer",
        "sample_count",
        "test_packages",
        "grower",
        "type",
        "field",
        "delivered",
        "viewed",
        /* "actions", */
      ],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      customer_id: this.$route.params.customer_id || null,
      table_config: this.lodash.merge(this.getDefaultTableConfig(), {
        options: {
          headings: {
            released_at: "Released At",
            customer: "Client",
            sample_count: "Samples",
            test_packages: "Test Package(s)",
          },
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
      type_collection: null,
      grower_collection: null,
    };
  },
  computed: {
    type_filters() {
      return this.types || this.type_collection;
    },
    grower_filters() {
      return this.growers || this.grower_collection;
    },
  },
  methods: {
    getData({ _reference }, data) {
      return getEntityData({
        entity: _reference,
        ...data,
      });
    },
    getGrower (row) {
      if (SubmissionExtensionTableDTO.getHoverTextStatic(row, 'attribute_1') == 'Grower') {
        return row.attribute_1
      }
    },
    prepareCollectionFilter(filter) {
      this.customer_id && filter.filterEquals("project.customer_id", this.customer_id);
      filter.filterEquals("project.laboratory_id", this.$store.getters.getLaboratoryContext.id);

      filter.filterNotNull("released_at")
      filter.filterNotNull("completed_at")

      filter.sortAddDesc("released_at", true)

      return filter;
    },
    async init() {
      const payload = {
        sort: [
          {
            logic: "sortAddAsc",
            field: "name",
          },
        ],
        limit: "all",
        message: this.$bvToast,
      };

      try {
        !this.types &&
          (this.type_collection = await getCollection({
            ...payload,
            collection_type: "sample_type",
          }));
        !this.growers &&
          (this.grower_collection = await new SubmissionCollection().fetchDirectory(
            "grower"
          ));
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
